// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import ConnectPage from "../pages/Connect/Connect";
const __wvcRoutePaths = ["/ConnectPage", "/connect"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["connect", "connectpage", "home", "homepage", "insights", "insightspage", "our-expertise", "ourexpertisepage", "post", "the-itls-approach", "theitlsapproachpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      
      
      
      
      <Route path={__wvcRoutePaths[0]} element={<ConnectPage />} />
      
      
      
      
      
      <Route path={__wvcRoutePaths[1]} element={<ConnectPage />} />
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
